import {
  CustomViewComponent,
  CustomViewPageCategory,
  CustomViewPages,
  CustomViewTemplateIdType,
  CustomViewTypeIdType,
} from '@agilelab/plugin-wb-platform';
import preview from './preview/marketplace_system/marketplace_system.png';
import thumbnail from './preview/marketplace_system/marketplace_system_thumbnail.png';

CustomViewPages.register({
  id: 'marketplace_system',
  meta: {
    label: 'System Detail Page',
    category: CustomViewPageCategory.MARKETPLACE,
    typeId: {
      type: CustomViewTypeIdType.SYSTEM_TYPE,
    },
    templateId: {
      type: CustomViewTemplateIdType.SYSTEM_TYPE,
    },
    preview: {
      thumbnail: { src: thumbnail },
      items: [{ src: preview }],
    },
  },
  data: (
    <CustomViewComponent type="grid_list">
      <CustomViewComponent type="include" id="marketplace_system_general" />
      <CustomViewComponent
        type="marketplace_tech_card"
        configPath="_computedInfo.legacyTechnicalInformationConfig"
      />
      <CustomViewComponent type="hbox" responsive>
        <CustomViewComponent type="grid_list" size={2}>
          {/* Components with multiple access request enabled */}
          <CustomViewComponent
            type="grid_sequence"
            path="_componentsByKind"
            showWhen={{
              value: '{{_computedInfo.multipleAccessRequestSelectionEnabled}}',
              equals: 'true',
            }}
          >
            <CustomViewComponent
              type="marketplace_component_card"
              title="{{ label }}"
            >
              <CustomViewComponent
                type="table"
                path="components"
                click="showComponent"
                filters={[
                  {
                    type: 'search',
                    column: 'Name',
                  },
                  {
                    type: 'multiselect',
                    column: 'Type',
                  },
                  {
                    type: 'multiselect',
                    column: 'Technology',
                  },
                  {
                    column: 'Access',
                    type: 'boolean',
                  },
                ]}
              >
                {/* Checkbox - show when multiple access request is enabled */}
                <CustomViewComponent
                  type="checkbox"
                  path="selected"
                  label=""
                  width="50"
                  maxWidth="50"
                  minWidth="50"
                  click="setSelection"
                  disabled="{% if shoppable is null or _parent._parent._computedInfo.shoppable === 'SHOPPABLE' %} true {% else %} false {% endif %}"
                  disabledTooltip="The project owner has not enabled individual access requests for this consumable "
                  resizable={false}
                />
                <CustomViewComponent
                  type="string"
                  path="name"
                  label="Name"
                  width="35%"
                  sortable
                />
                <CustomViewComponent
                  type="violations-status-summary"
                  path="_policyViolationCount"
                  label="policies"
                  width="100"
                />
                <CustomViewComponent type="string" path="type" label="Type" />
                <CustomViewComponent
                  type="string"
                  path="version"
                  label="Version"
                />
                <CustomViewComponent
                  type="string"
                  path="descriptor.technology"
                  label="Technology"
                />
                <CustomViewComponent
                  type="icon"
                  path="accessStatus.summary"
                  label="Access"
                  tooltip="{{accessStatus.description}}"
                  map={{
                    access: 'has_access',
                    partial_access: 'partial_access',
                    non_consumable: 'no_access',
                    no_access: 'no_access',
                  }}
                />
              </CustomViewComponent>
            </CustomViewComponent>
          </CustomViewComponent>
          {/* Components with multiple access request disabled */}
          <CustomViewComponent
            type="grid_sequence"
            path="_componentsByKind"
            showWhen={{
              value: '{{_computedInfo.multipleAccessRequestSelectionEnabled}}',
              notEquals: 'true',
            }}
          >
            <CustomViewComponent
              type="marketplace_component_card"
              title="{{ label }}"
            >
              <CustomViewComponent
                type="table"
                path="components"
                click="showComponent"
                filters={[
                  {
                    type: 'search',
                    column: 'Name',
                  },
                  {
                    type: 'multiselect',
                    column: 'Type',
                  },
                  {
                    type: 'multiselect',
                    column: 'Technology',
                  },
                  {
                    column: 'Access',
                    type: 'boolean',
                  },
                ]}
              >
                {/* Checkbox - show when multiple access request is enabled */}
                <CustomViewComponent
                  type="radio"
                  path="selected"
                  label=""
                  width="50"
                  maxWidth="50"
                  minWidth="50"
                  click="setSelection"
                  disabled="{% if shoppable is null or _parent._parent._computedInfo.shoppable === 'SHOPPABLE' %} true {% else %} false {% endif %}"
                  disabledTooltip="The project owner has not enabled individual access requests for this consumable "
                  resizable={false}
                />
                <CustomViewComponent
                  type="string"
                  path="name"
                  label="Name"
                  width="35%"
                  sortable
                />
                <CustomViewComponent
                  type="violations-status-summary"
                  path="_policyViolationCount"
                  label="policies"
                  width="100"
                />
                <CustomViewComponent type="string" path="type" label="Type" />
                <CustomViewComponent
                  type="string"
                  path="version"
                  label="Version"
                />
                <CustomViewComponent
                  type="string"
                  path="descriptor.technology"
                  label="Technology"
                />
                <CustomViewComponent
                  type="icon"
                  path="accessStatus.summary"
                  label="Access"
                  tooltip="{{accessStatus.description}}"
                  map={{
                    access: 'has_access',
                    partial_access: 'partial_access',
                    non_consumable: 'no_access',
                    no_access: 'no_access',
                  }}
                />
              </CustomViewComponent>
            </CustomViewComponent>
          </CustomViewComponent>
        </CustomViewComponent>
        <CustomViewComponent type="grid_list" size={1}>
          <CustomViewComponent type="marketplace_review" />
          <CustomViewComponent type="marketplace_questions" />
        </CustomViewComponent>
      </CustomViewComponent>
    </CustomViewComponent>
  ),
});
